// Ends one cart-update round-trip. Extracted from doUpdate so it can be unit-tested without a DOM.
//
// Both parts run even when the update failed, because both are about the request being over rather than about
// it having worked:
//
//   - Leave the latch set and every later doUpdate early-returns. The buyer's total then silently stops
//     responding to them and the server never hears about the change they made — which is how a buyer can pick
//     a new country, still see the old total, and have the purchase priced on a country we were never told
//     about.
//   - A change queued while this request was in flight is the buyer's most recent one. Dropping it strands
//     exactly the edit they are waiting to see, so replay it rather than clear it.
//
// Deliberately not in here: incrementing data-cart-update-counter. That is assert_cart_updated's success
// condition, so bumping it after a failed render would let a test claiming "the cart updated" pass over a cart
// that didn't. It stays on the success path, where a broken render times the helper out and fails, which is the
// signal we want.
//
// Call this exactly once per round-trip: it can start the queued update, and a second call would then clear the
// latch belonging to that new request while it is still in flight.
export function finishCartUpdate(form, { retry }) {
  form.removeAttribute('data-loading-cart-update')
  form.removeAttribute('data-request-in-progress')

  if (!form.getAttribute('data-pending-cart-update')) return

  form.removeAttribute('data-pending-cart-update')
  retry()
}
